import React, { useContext } from 'react';
import { Space, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Header } from './styled';
import commonSelector from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';
import { saveThresholdData } from '@store/noc/threshold/actions';
import ParentContext from '@src/pages/Noc/Threshold/context';
import { AI_ALERT } from '@components/noc-metric-panel/utils/constants';
import { setAllThresholdCellSelection } from '@store/noc/base/actions';

export type ActionsProps = {
  callback?: () => void;
};

function Actions({ callback }: ActionsProps) {
  const parentContext = useContext(ParentContext);
  const { thresholdConfig, hasError } = parentContext;

  const dispatch = useDispatch();
  const commonStore = useSelector(commonSelector);
  const aiAlertsEnabled = commonStore.features[featureNames[AI_ALERT]];
  const aiThresholdEnabled = commonStore.features[featureNames.REALTIME_AI_THRESHOLD];
  const save = () => {
    dispatch(saveThresholdData(thresholdConfig, callback));
  };

  const setThreshold = (selection: 'conviva' | 'custom') => {
    dispatch(setAllThresholdCellSelection(selection));
  };

  return (
    <Space direction="vertical">
      <Header>Actions</Header>
      <Button onClick={save} type="text" size="small" icon={<SaveOutlined />} disabled={hasError}>
        Save
      </Button>
      {aiAlertsEnabled && aiThresholdEnabled && (
        <Button onClick={() => setThreshold('conviva')} type="text" size="small">
          Select All Conviva Threshold
        </Button>
      )}
      {aiAlertsEnabled && aiThresholdEnabled && (
        <Button onClick={() => setThreshold('custom')} type="text" size="small">
          Select All Custom Threshold
        </Button>
      )}
    </Space>
  );
}

export default Actions;
